﻿import { FocusTrap } from "./accessibility/accessibility";

export class DropDown {

    focusTrap: FocusTrap;
    active: boolean = false;
    triggers: Array<HTMLButtonElement | HTMLAnchorElement> = [];

    private _root: HTMLElement;
    set root(el: HTMLElement) {
        this._root = el;
        this.focusTrap = new FocusTrap(el);
    }
    get root() {return this._root }
    constructor() {

        //const btn = root.querySelector('[dropdown]');
        //const target = btn.getAttribute('dropdown');
        //const dropdown = root.querySelector(`#${target}`);

        //btn.addEventListener('click', ev => {
        //    dropdown.classList.remove('active');
        //});

    }

    addTrigger(el: HTMLButtonElement | HTMLAnchorElement) {
        this.triggers.push(el);

        el.addEventListener('click', ev => {
            this.toggle();
        })
    }

    show() {
        if (this.active) return;

        this.active = true;
        this.root.classList.add('active');

        this.focusTrap.escapeTrap = this.focusTrap.trapFocus()
    }

    hide() {
        this.active = false;
        this.root.classList.remove('active');
        this.focusTrap.escapeTrap();
    }

    toggle() {
        if (this.active) return this.hide();
        this.show();
    }
}